module.exports = __webpack_public_path__ + "static/media/Fish – 1.46386d62.jpg";